/* @flow */

import invariant from 'invariant';
import axios from 'axios';

const getDadosFormularioModal = () => {
    const apelido = document.querySelector('#apelidoModal');
    const email = document.querySelector('#emailModal');
    const senha = document.querySelector('#senhaModal');

    invariant(apelido instanceof HTMLInputElement, '');
    invariant(email instanceof HTMLInputElement, '');
    invariant(senha instanceof HTMLInputElement, '');

    return {
        apelido: apelido.value,
        email: email.value,
        senha: senha.value,
    };
};

const onSuccess = ({ data: { mensagem, retorno } }) => {
    const container = document.querySelector('#manterLogado');
    const textDanger = document.querySelector('#manterLogado form span.text-danger');

    invariant(textDanger, '');
    invariant(container, '');

    if (mensagem) {
        textDanger.innerText = mensagem;
    }

    if (!retorno) {
        return;
    }

    container.innerHTML = '';
};

export default function manterLogado(resultado: Object) {
    const $ = document.querySelector.bind(document);
    if (document.body) {
        document.body.insertAdjacentHTML('beforeend', resultado.html);
    }

    const enviar = document.querySelector('.manterLogadoFooter .enviar');
    const cancelar = document.querySelector('.manterLogadoFooter button');

    invariant(enviar, '');
    invariant(cancelar, '');

    enviar.onclick = () => {
        axios
            .post('/ajax-login', getDadosFormularioModal())
            .then(onSuccess);
    };

    cancelar.onclick = () => {
        location.reload();
        const container = document.querySelector('#manterLogado');
        invariant(container, '');
        container.innerHTML = '';
    };
}



// WEBPACK FOOTER //
// ./app/utils/manter-logado.js